// Auto-generated product catalogue from ceaindia.in (scraped & cleaned).
export const catalogue = [
  {
    slug: "analog-and-digital-trainer-kits",
    category: "education",
    title: "Analog/Digital Trainer Kits",
    products: [
      {
        name: "Digital Trainer Kit - 01",
        image: "/products/156ea5_digital-trainer-kit-250x250.jpg",
        description: "",
        bullets: [
          "10 Logic Level Inputs & 10 LED for output indication.",
          "Fixed Clock generation of 1Hz, 10Hz, 100Hz, 1KHz, 10KHz, 100KHz & 1MHz.",
          "Logic pulsar, logic probe, potentiometers of 1K, 10K 100K",
          "Bread Board of 1260 tie points",
          "Sine, Square and Triangular output waveform from 0-200Khz.",
          "Fixed DC, Variable DC, AC power supply.",
          "All interconnections are made using 2mm banana Patch cord.",
        ],
      },
      {
        name: "Digital Trainer Kit - 02",
        image: "/products/0db714_digital-trainer-kit-250x250.jpg",
        description: "",
        bullets: [
          "10 logic level inputs & 10 LED for output indication.",
          "Bread Board of 630 tie points.",
          "Sine, square and triangular output waveform from 0-200Khz.",
          "Fixed DC, variable DC, AC power supply.",
          "All interconnections are made using 2mm banana Patch cord.",
        ],
      },
      {
        name: "Digital Trainer Kit - 03",
        image: "/products/4dc28a_digital-trainer-kit-250x250.jpg",
        description: "",
        bullets: [
          "10 Logic Level Inputs & 10 LED for output indication.",
          "Fixed Clock generation of 1Hz, 10Hz, 100Hz, 1KHz, 10KHz, 100KHz & 1MHz.",
          "Logic Pulsar, Logic Probe",
          "4 digit 7 Segment Display",
          "Bread Board of 1260 tie points",
          "Fixed DC +5V, ±12V power supply.",
          "All interconnections are made using 2mm banana Patch cord.",
        ],
      },
      {
        name: "Digital Trainer Kit - 04",
        image: "/products/383614_digital-trainer-kit-250x250.jpg",
        description: "",
        bullets: [
          "10 logic level inputs & 10 LED for output indication.",
          "Fixed Clock generation of 1Hz, 10Hz, 100Hz, 1KHz, 10KHz, 100KHz & 1MHz.",
          "Logic pulsar, logic probe, four digit BCD 7-Segment Display.",
          "Bread Board of 1260 tie points.",
          "Fixed DC +5V, ±12V power supply.",
          "All interconnections are made using 2mm banana Patch cord.",
        ],
      },
      {
        name: "Digital IC Trainer Kit",
        image: "/products/aa4113_digital-ic-trainer-kit-250x250.jpg",
        description: "",
        bullets: [
          "10 Logic Level Inputs & 10 LED for output indication.",
          "Fixed Clock generation of 1Hz, 10Hz, 100Hz, 1KHz, 10KHz, 100KHz & 1MHz.",
          "Logic Pulsar, Logic Probe, Three Digit 7-Segment Display.",
          "Bread Board of 630 tie points",
          "One IC each of 7400, 7402, 7408, 7432, 7404, 7490, 7495, 7486, 7447 & Two Nos. of IC 747.",
          "20 Pin Socket- 1No.",
          "Fixed DC +5V, ±12V power supply.",
          "All interconnections are made using 2mm banana Patch cord.",
        ],
      },
      {
        name: "Basic Electronics Trainer Kit",
        image: "/products/60690a_basic-electronics-trainer-kit-250x250.jpg",
        description: "Analog and Digital Trainer Kits",
        bullets: [
          "16 Logic Level Inputs & 16 LED for output indication.",
          "Fixed Clock generation of 1Hz, 10Hz, 100Hz, 1KHz, 10KHz, 100KHz & 1MHz.",
          "Dual Logic Pulsar, Logic Probe, SPDT Relay, Buzzer, Bar LED display, DPM for Voltage & Current, Potentiometers of 1K, 1M,",
          "Two digit 7 segment display with HEX to 7 segment decoder.",
          "Bread Board of 1260 tie points",
          "Sine, Square and Triangular output waveform from 0-200Khz.",
          "Fixed DC +5V, ±12V power supply.",
          "All interconnections are made using 2mm banana Patch cord.",
          "Home",
          "Analog/Digital Trainer Kits",
        ],
      },
    ],
  },
  {
    slug: "basic-communication-trainers",
    category: "education",
    title: "Basic Communication Trainers",
    products: [
      {
        name: "Amplitude Modulation- Demod - Kit",
        image: "/products/9282e0_bct-01-amplitude-modulation-demod-kit-250x250.jpg",
        description: "",
        bullets: [
          "Provides sine waveform output Frequency variable from 20 Hz.-20 KHz",
          "Carrier generation output of 40 KHz and Max. 2V p-p.",
          "AM-modulator circuit using IC3086.",
          "AM-Demodulator using Diode detector method.",
        ],
      },
      {
        name: "Frequency Modulation- Demod - Kit",
        image: "/products/66cf85_bct-02-frequency-modulation-demod-kit-250x250.jpg",
        description: "",
        bullets: [
          "Provides sine waveform output frequency variable from 20 Hz.-20 KHz",
          "Provides carrier waveform output of 50 KHz and Max. 5V p-p.",
          "FM -modulator circuit using IC2206",
          "FM -Demodulator using PLL.",
        ],
      },
      {
        name: "Pam Modulation-demodulation - Kit",
        image: "/products/5c275f_bct-06-pam-modulation-demodulation-kit-250x250.jpg",
        description: "",
        bullets: [
          "Provides sine waveform output frequency variable from 100 Hz.-1.5 KHz",
          "Carrier Generation variable output of 6KHz to 50KHz",
          "PAM -modulator circuit using IC4066",
          "PAM -demodulator using low pass Filter .",
        ],
      },
      {
        name: "PWM Modulation-Demodulation - KIT",
        image: "/products/de6984_bct-07-pwm-modulation-demodulation-kit-250x250.jpg",
        description: "",
        bullets: [
          "Provides Sine waveform output variable from 1KHz.-1.2 KHz.",
          "Sampling frequency generation output of 34 KHz.",
          "PWM -modulator circuit using IC555",
          "PWM -Demodulator using low pass filter.",
        ],
      },
      {
        name: "PPM Modulation-Demodulation Kit",
        image: "/products/c83e1b_bct-08-ppm-modulation-demodulation-kit-250x250.jpg",
        description: "",
        bullets: [
          "Provides Sine waveform output variable from 1KHz.-1.2 KHz.",
          "Sampling frequency generation TTL output of 34 KHz.",
          "PPM -modulator circuit using IC555",
          "PPM -Demodulator Low Pass Filter.",
        ],
      },
      {
        name: "TDM Modulation-Demodulation KIT",
        image: "/products/bbfb54_bct-09-tdm-modulation-demodulation-kit-250x250.jpg",
        description: "",
        bullets: [
          "Provides dual sine waveform output of 125 Hz & 200 Hz with variable amplitude",
          "Sampling Frequency generation TTL output of 40 KHz.",
          "Two channel multiplexing & de-multiplexing",
          "TDM -modulator circuit using IC4066 & demodulator using IC 4066.",
          "On-board 4th order Low pass filter with cut-off frequency of 3.4khz.",
        ],
      },
      {
        name: "PCM Modulation-Demodulation KIT",
        image: "/products/91f8ec_bct-10-pcm-modulation-demodulation-kit-250x250.jpg",
        description: "",
        bullets: [
          "Provides dual sine waveform output of 30 Hz with variable amplitude",
          "Sampling Frequency generation TTL output of 25 KHz.",
          "PCM modulation using 74163 & ADC0800 displayed in 8 Led’s",
          "PCM demodulation using 74165 & DAC0800 displayed in 8 Led’s.",
          "On-board Low pass filter.",
        ],
      },
      {
        name: "FSK Modulation-Demodulation Kit",
        image: "/products/9a17aa_bct-11-fsk-modulation-demodulation-kit-250x250.jpg",
        description: "",
        bullets: [
          "Clock generation output of 15 KHz.",
          "Four Nos. of data clock using IC 7490.",
          "FSK -modulator circuit using IC 74163 and IC 7400",
          "FSK -demodulator using IC TL084.",
        ],
      },
      {
        name: "ASK Modulation-Demodulation KIT",
        image: "/products/73467d_bct-12-ask-modulation-demodulation-kit-250x250.jpg",
        description: "",
        bullets: [
          "Programmable cyclic 8-bit word generator.",
          "Sine waveform output maximum up to 30 KHz.",
          "ASK -modulator circuit using IC 4066.",
          "ASK -Demodulator using IC TL084.",
          "Eight LED display to verify the input data.",
        ],
      },
      {
        name: "PSK Modulation-Demodulation KIT",
        image: "/products/deb78c_bct-13-psk-modulation-demodulation-kit-250x250.jpg",
        description: "",
        bullets: [
          "Sine waveform output from 10KHz. - 20 KHz.",
          "Four Nos. of data Clock using IC 7490.",
          "PSK -modulator circuit using IC 4051 and IC TL084.",
          "PSK -demodulator using IC 7486.",
        ],
      },
      {
        name: "Delta Modulation-Demodulation KIT",
        image: "/products/282d92_bct-14-delta-modulation-demodulation-kit-250x250.jpg",
        description: "",
        bullets: [
          "Sine waveform output of 250Hz.",
          "Square waveform output of 20 KHz.",
          "DELTA -modulator circuit using IC 74193 UP DOWN counter and DAC-0800.",
          "DELTA -demodulator using IC TL084.",
        ],
      },
      {
        name: "QPSK Modulation-Demodulation KIT",
        image: "/products/9b37f8_bct-17-qpsk-modulation-demodulation-kit-250x250.jpg",
        description: "",
        bullets: [
          "Provides Four quadri- phase carrier output generated using IC 7490.",
          "100KHz (0°), 100KHz (90°), 100KHz (180°), 100KHz (270°)",
          "Synchronous data generator using IC 74165.",
          "Switch selectable simulated data stream generated at approx.1Kb/s rate.",
          "QPSK -modulator circuit & QPSK -Demodulator.",
        ],
      },
      {
        name: "DPSK Modulation-Demodulation Kit",
        image: "/products/6dcb15_bct-18-dpsk-modulation-demodulation-kit-250x250.jpg",
        description: "",
        bullets: [
          "Sine waveform output variable from 10KHz. - 20 KHz.",
          "Four Nos. of Data Clock using IC 7490",
          "DPSK -modulator circuit using IC TL084 and Two Nos. of IC 4051 .",
          "DPSK -demodulator using IC 7486 and IC 74164.",
        ],
      },
      {
        name: "Linear IC Trainer Kit",
        image: "/products/f991f1_linear-ic-trainer-kit-250x250.jpg",
        description: "Basic Communication Trainers",
        bullets: [
          "4 LED for output indication.",
          "Bread Board of 630 tie points",
          "One IC each of 555, 741, LF398, MCT2E, Transistor, Diodes.",
          "Resistor & Capacitor bank, SPDT Relay, Speaker.",
          "Two 8 Pin Socket, Potentiometers of 1K, 10K 100K",
          "Sine, square and triangular output waveform from 0-200Khz.",
          "Fixed DC, Variable DC, AC power supply.",
          "All interconnections are made using 2mm banana Patch cord.",
          "Home",
          "Analog/Digital Trainer Kits",
        ],
      },
    ],
  },
  {
    slug: "digital-communication-trainers",
    category: "education",
    title: "Digital Communication Trainers",
    products: [
      {
        name: "Analog Sampling-Reconstruction Kit",
        image: "/products/2c6774_act-01-analog-sampling-reconstruction-kit-250x250.jpg",
        description: "",
        bullets: [
          "Synchronized Sine waveform output of Frequency 1 KHz & 2 KHz.",
          "Selectable sampling frequency of 2,4,8,16,32 KHz.",
          "Sample circuit/output, sample & hold circuit/output",
          "Switch selectable sampling Duty cycle of 0-90% in steps.",
          "2nd & 4th order Low pass filter.",
        ],
      },
      {
        name: "PAM-PWM-PPM-Modulation-Demodulation Kit",
        image: "/products/24831d_act-02-pam-pwm-ppm-modulation-demodulation-kit-250x250.jpg",
        description: "",
        bullets: [
          "Sine waveform output of 250Hz, 500Hz, 1 KHz, and 2 KHz",
          "Selectable sampling clock of 4, 8, 16, 32 KHz.",
          "Analog Sample Circuit/Output, Sample & Hold Circuit/Output, Flat Top Circuit/Output",
          "PAM/PWM/PPM modulation & demodulation.",
          "4th order Low pass filter.",
        ],
      },
      {
        name: "TDM-Pulse Amplitude Mod-Demod- Kit",
        image: "/products/f444a3_act-03-tdm-pulse-amplitude-mod-demod-kit-250x250.jpg",
        description: "",
        bullets: [
          "Sine waveform output of 250Hz, 500Hz, 1 KHz, and 2 KHz",
          "Sampling rate of 32 KHz/channel, 8KHz. Channel Identification Signal.",
          "DC source for Amplitude adjustments provided.",
          "Four analog input channels for multiplexing/de-multiplexing.",
          "Clock regeneration at receiver using PLL.",
          "4th order Butter worth Low pass.",
        ],
      },
      {
        name: "TDM-Pulse Code Modulation Kit",
        image: "/products/0e48da_act-04-tdm-pulse-code-modulation-kit-250x250.jpg",
        description: "",
        bullets: [
          "Sine waveform output of 500Hz, 1 KHz",
          "Two Nos. of variable DC source with Amplitude adjustments.",
          "Fast (240 KHz/Channel approx)/ Slow (1Hz. /channel approx.).",
          "Two Nos. of Input Channels..",
          "Pseudo random sync. Code generator for FRAME Synchronization. .",
          "PLL for Bit synchronization.",
        ],
      },
      {
        name: "TDM-Pulse Code Modulation KIT",
        image: "/products/87753d_act-05-tdm-pulse-code-modulation-kit-250x250.jpg",
        description: "",
        bullets: [
          "2 Channel TDM Pulse Code Modulation Receiver.",
          "Pseudo random sync. Code generator for FRAME Synchronization.",
          "Receiver clock generation using PLL",
          "Error Detection of None, Even, Odd, Hamming.",
          "Error Correction using Hamming Code technique.",
          "Two Nos. of 4th order butter worth Low pass filter.",
        ],
      },
      {
        name: "Delta-Adaptive Delta-M-D-KIT",
        image: "/products/1b9cc4_act-06-delta-adaptive-delta-m-d-kit-250x250.jpg",
        description: "",
        bullets: [
          "Sine waveform output of 250Hz,500Hz, 1 KHz and 2 KHz",
          "Switch selectable sampling clock of 8, 16, 32,64 KHz.",
          "Delta modulation, Adaptive Delta modulation, CVSD modulation",
          "M-law Com pander and Expander .",
          "2nd & 4th order Butter worth Low pass filter.",
        ],
      },
      {
        name: "Data Conditioning Kit",
        image: "/products/93275b_act-7t-data-conditioning-kit-250x250.jpg",
        description: "",
        bullets: [
          "Carrier Generator generating frequency of 2MHz (0°), 1MHz (0°) & 1MHz (180°)",
          "NRZ(Level), NRZ(Mark), NRZ(Space), Biphase (Manchester), Biphase (Mark), Biphase (Space), URZ, AMI.",
          "ASK modulation, FSK modulation, PSK modulation",
          "Uni-polar to Bipolar conversion & Bipolar to Uni-polar conversion.",
        ],
      },
      {
        name: "Data RE-Conditioning KIT",
        image: "/products/4d781e_act-7r-data-re-conditioning-kit-250x250.jpg",
        description: "",
        bullets: [
          "NRZ(Level), NRZ(Mark), NRZ(Space), Bi-phase (Manchester), Bi-phase (Mark), Bi-phase (Space), URZ, AMI.",
          "Rectifier Diode for ASK modulation, PLL Detector for FSK modulation, Square Loop Detector for PSK modulation .",
          "Receiver Clock generated using PLL",
        ],
      },
      {
        name: "BPSK-DPSK Modulation-Demodulation KIT",
        image: "",
        description: "",
        bullets: [
          "Provides synchronized Sine waveform output of 500KHz(0 deg.), 500KHz(180 deg.).",
          "8 bit variable NRZ-L pattern generated depending on the position of the 8-dit Data Switch provided.",
          "Non Return to Zero-Level (NRZ-L).",
          "BPSK modulation, DPSK modulation, DEPSK modulation.",
          "Square Looping Technique used in Demodulation section.",
        ],
      },
      {
        name: "QPSK-DQPSK Modulation Kit - 01",
        image: "/products/5c60cd_adct-02-qpsk-dqpsk-modulation-kit-250x250.jpg",
        description: "",
        bullets: [
          "Provides synchronized Sine waveform output of 500KHz(0 deg.), 500KHz(90 deg.), 500KHz(180 deg.), 500KHz(270deg.).",
          "Digit Pair (I & Q), differential encoding of I & Q bits.",
          "DPSK modulation, DQPSK modulation.",
          "Clock frequency of 250 KHZ BIT, BIT clock, word clock.",
          "On board 8 bit variable NRZ-L pattern data simulator.",
        ],
      },
      {
        name: "QPSK-DQPSK Modulation Kit - 02",
        image: "/products/d29714_adct-03-qpsk-dqpsk-modulation-kit-250x250.jpg",
        description: "",
        bullets: [
          "Dibit Pair (I & Q), differential encoding of I & Q bits.",
          "DPSK Demodulation, DQPSK demodulation.",
          "Receiver Clock generated by PLL method.",
        ],
      },
      {
        name: "Base Band Digital Transmission Trainer",
        image: "/products/0cacab_adct-04-base-band-digital-transmission-trainer-250x250.jpg",
        description: "",
        bullets: [
          "Provides White Noise Source output.",
          "selectable clock rate of 16, 32, 64, 128, 256, 512 KHz, and 1.024 MHz.",
          "Four digit counter displayed on seven segment for BER measurement.",
          "Four digit seven segment counting up to 9999 with LED for TC.",
          "Pulse Amplitude Modulation technique is used .",
          "Internal sampling clock: of 16 KHz to 1MHz.",
          "16 bit data pattern for scrambler/ unscrambler.",
        ],
      },
      {
        name: "QAM-DQAM Modulation Trainer - 01",
        image: "/products/08a413_adct-05-qam-dqam-modulation-trainer-250x250.jpg",
        description: "",
        bullets: [
          "Provides synchronized Sine waveform output of 500KHz(0 deg.), 500KHz(90 deg.), 500KHz(180 deg.),500KHz(270 deg.).",
          "24 bit variable NRZ-L pattern generated depending on the position of the three nos. of 8-dit Data Switch provided.",
          "Non Return to Zero-Level (NRZ-L), Tribit encoded data (I ,Q & C), Differential Encoded I & Q Bits.",
          "Quadrature amplitude modulation, differentially quadrature amplitude modulation.",
        ],
      },
      {
        name: "QAM-DQAM Modulation Trainer - 02",
        image: "/products/d969bb_adct-06-qam-dqam-modulation-trainer-250x250.jpg",
        description: "",
        bullets: [
          "Receiver clock generated using PLL method.",
          "Non Return to Zero-Level (NRZ-L), Tribit Decoded data (I ,Q & C), Differential Decoded I & Q Bits.",
          "Quadrature amplitude demodulation, differentially quadrature amplitude demodulation .",
          "QAM/DQAM demodulation using PLL and envelop detectors.",
        ],
      },
      {
        name: "DPCM-ADPCM Modulation-Demodulation Trainer",
        image: "/products/2e7ee9_adct-07-dpcm-adpcm-modulation-demodulation-trainer-250x250.jpg",
        description: "Digital Communication Trainers",
        bullets: [
          "Provides Sine waveform output using IC 74164.",
          "Clock of frequencies ?64 KHz, 128 KHz, 256 KHz and 512KHz.",
          "Sampling Clock Frequency of 16 KHz and Amplitude of 5V.",
          "DPCM modulation using sampler, quantizer and linear predictor.",
          "DPCM demodulation using linear predictor, Integrator and Low pass Filter.",
          "Home",
          "Analog/Digital Trainer Kits",
          "Basic Communication Trainers",
          "Digital Communication Trainers",
          "Embedded Development Board",
        ],
      },
    ],
  },
  {
    slug: "embedded-development-board",
    category: "education",
    title: "Embedded Development Board",
    products: [
      {
        name: "MCU Embedded Trainer",
        image: "/products/3d989d_mcu-embedded-trainer-250x250.jpg",
        description: "",
        bullets: [
          "CPU: Philips 89C61X2 Microcontroller",
          "ISP Programming facility.",
          "On-board interface like 8 I/P switches, 8 Led output, 16x2 LCD display, 4 digit 7-segment display, I2C like 24c512, DS1307 RTC, 8 bit ADC & DAC, Temperature sensor DS18B20",
          "24 I/O Lines Provided on a 26 pin FRC Connector for external interface",
          "In-built Power supply of +/- 12V, +5V.",
        ],
      },
      {
        name: "ARM Embedded Trainer",
        image: "/products/2bdec4_e87-02-arm-embedded-trainer-250x250.jpg",
        description: "",
        bullets: [
          "CPU: Philips LPC 2148 Microcontroller",
          "ISP programming facility.",
          "On-board interface like 8 I/P switches, 8 Led output, 16x2 LCD display, 4 digit 7-segment display, I2C like 24c512, DS1307 RTC, 8 bit ADC & DAC, temperature sensor DS18B20",
          "24 I/O lines provided on a 26 pin FRC connector for external interface",
          "In-built Power supply of +/- 12V, +5V.",
        ],
      },
      {
        name: "PIC Embedded Trainer",
        image: "/products/859d67_e87-03-pic-embedded-trainer-250x250.jpg",
        description: "",
        bullets: [
          "CPU: Microchip 16F877A / 18F452 Microcontroller",
          "ISP Programming facility.",
          "On-board interface like 8 I/P switches, 8 Led output, 16x2 LCD display, 4 digit 7-segment display, I2C like 24c512, DS1307 RTC, 8 bit ADC & DAC, Temperature sensor DS18B20",
          "24 I/O Lines Provided on a 26 pin FRC Connector for external interface",
          "In-built Power supply of +/- 12V, +5V.",
        ],
      },
      {
        name: "AVR Embedded Trainer",
        image: "/products/32a7a2_e87-04-avr-embedded-trainer-250x250.jpg",
        description: "",
        bullets: [
          "CPU: ATMEL Atmega32 microcontroller",
          "ISP programming facility.",
          "On-board interface like 8 I/P switches, 8 Led output, 16x2 LCD display, 4 digit 7-segment display, I2C like 24c512, DS1307 RTC, 8 bit ADC & DAC, Temperature sensor DS18B20",
          "24 I/O Lines Provided on a 26 pin FRC Connector for external interface",
          "In-built Power supply of +/- 12V, +5V.",
        ],
      },
      {
        name: "Universal Embedded Trainer",
        image: "/products/ac78a4_uet-01-universal-embedded-trainer-250x250.jpg",
        description: "Embedded Development Board",
        bullets: [
          "CPU: Boards compatible for 89C61X2, PIC 16F877A, LPC 2148, AT mega16 microcontrollers.",
          "ISP Programming facility.",
          "On-board interface like 8 I/P switches, 8 Led output, 16x2 LCD display, 4 digit 7-segment display, I2C like 24c512, DS1307 RTC, 8 bit ADC & DAC, Temperature sensor DS18B20",
          "LM35 temperature sensor, 4x4 matrix keyboard, Relay, Buzzer.",
          "24 I/O Lines Provided on a 26 pin FRC Connector for external interface",
          "In-built Power supply of +/- 12V, +5V.",
          "Home",
          "Analog/Digital Trainer Kits",
          "Basic Communication Trainers",
          "Digital Communication Trainers",
        ],
      },
    ],
  },
  {
    slug: "eprom-programmer",
    category: "education",
    title: "EPROM Programmer",
    products: [
      {
        name: "Top-85x-Universal Programmer-Tester",
        image: "",
        description: "",
        bullets: [
          "Device supports more than 4000+ devices",
          "40 Pin ZIF socket with universal pin-drivers. to supports 8-pin to 40-pin DIP package device",
          "USB Interface to LAPTOP & PC.",
          "High speed programming, Cost effective Hardware and Flexible Software",
        ],
      },
      {
        name: "Top-85x-Universal Programmer-Tester",
        image: "",
        description: "",
        bullets: [
          "Device supports more than 7000+ devices",
          "48 Pin ZIF socket with universal pin-drivers. to supports 8-pin to 40-pin DIP package device",
          "USB Interface to LAPTOP & PC.",
          "High speed programming, Cost effective Hardware and Flexible Software",
        ],
      },
      {
        name: "Top-3000-Universal Programmer-Tester",
        image: "",
        description: "",
        bullets: [
          "Device supports more than 15000+ devices",
          "48 Pin ZIF socket with universal pin-drivers. to supports 8-pin to 40-pin DIP package device",
          "USB Interface to LAPTOP & PC.",
          "High speed programming, Cost effective Hardware and Flexible Software",
        ],
      },
      {
        name: "EE-I-Eprom Eraser",
        image: "/products/2c23c1_imag.jpg",
        description: "",
        bullets: [
          "Auto shut OFF after predetermined time, selectable by the Timer.",
          "Built in spring loaded mechanical timer with auto rewinding for setting time 0-30/60 minutes.",
          "6\"/9\" Ultra Violet Tube.",
          "8 to 10 EPROMs can be erased at a time.",
          "Home",
          "Analog/Digital Trainer Kits",
          "Basic Communication Trainers",
          "Digital Communication Trainers",
          "Embedded Development Board",
          "Eprom Programmer",
        ],
      },
    ],
  },
  {
    slug: "function-generator",
    category: "education",
    title: "Function Generator",
    products: [
      {
        name: "Function Generator",
        image: "/products/8afcac_kfg-02a-function-generator-250x250.jpg",
        description: "",
        bullets: [
          "Sine/Triangle/Square output.",
          "Frequency range from .02Hx to 2MHz.",
          "Maximum output voltage 20Vp-p.",
          "Attenuator of 0-60db.",
          "Variable duty cycle & DC Offset.",
          "50Mhz Frequency Counter.",
          "Home",
          "Analog/Digital Trainer Kits",
          "Basic Communication Trainers",
          "Digital Communication Trainers",
        ],
      },
    ],
  },
  {
    slug: "ic-tester",
    category: "education",
    title: "IC Tester",
    products: [
      {
        name: "Digital IC Tester - 01",
        image: "/products/01038b_dict-01-digital-ic-tester-250x250.jpg",
        description: "",
        bullets: [
          "Can test more than 300+ ICs",
          "Tests wide range of Digital IC's such as 74 Series, 40/45 Series",
          "24 pin DIP ZIF sockets.",
          "Auto Search facility for listed IC's.",
          "16 keys and 16 x 1 line LCD display.",
        ],
      },
      {
        name: "Universal IC Tester - 01",
        image: "/products/c6d06e_dict-02-universal-ic-tester-250x250.jpg",
        description: "",
        bullets: [
          "Can test more than 450+ ICs",
          "Tests a wide range of Digital IC's such as 74 Series, 40/45 Series, 8085, 8086, Z80,8255, 8279, 8253, 8259, 8251, 8155, 6264, 62256, 8288, 8284",
          "Tests Op-amp, 555, Transistor Arrays, Analog switches, Opto couplers and Others",
          "Tests 7- Segment display of common cathode & common anode type",
          "Auto search facility of all Digital ICs",
          "40 pin DIP ZIF sockets",
          "28 Keys Touch Keypad and 9 Digit Seven Segment Display.",
        ],
      },
      {
        name: "Universal IC Tester - 02",
        image: "/products/fc9930_dict-03-universal-ic-tester-250x250.jpg",
        description: "",
        bullets: [
          "Can test more than 1500+ ICs",
          "Tests a wide range of digital IC's such as 74 Series, 40/45 Series, 8085, 8086, Z80 ,8255, 8279, 8253, 8259, 8251, 8155, 6264, 62256, 8288, 8284",
          "Tests a wide range of analog IC's such as Op-amps, Timers, Transistor Arrays, Analog switches, Opto- couplers, ADC, DAC, Voltage Regulator, etc",
          "Tests 7- segment display of common cathode & common anode type",
          "Auto search facility of all Digital ICs",
          "40 pin DIP ZIF socket, 50 cherry keys Key pad and 16 X 2 LCD",
        ],
      },
      {
        name: "Linear IC Tester",
        image: "/products/2ecebf_dict-05-linear-ic-tester-250x250.jpg",
        description: "",
        bullets: [
          "Can test more than 600+ ICs",
          "Tests a wide range of Analog IC's such as Op-amps, timers, transistor arrays, analog switches, Op to- couplers, ADC, DAC, voltage regulator, etc",
          "40 pin DIP ZIF socket.",
          "50 cherry keys Key pad and 16 X 2 LCD Display.",
        ],
      },
      {
        name: "Digital IC Tester - 02",
        image: "/products/c7ad76_dict-06-digital-ic-tester-250x250.jpg",
        description: "",
        bullets: [
          "Can test more than 450+ ICs",
          "Tests a wide range of Digital IC's such as 74 Series, 40/45 Series, 8085, 8086, Z80 ,8255, 8279, 8253, 8259, 8251, 8155, 6264, 62256, 8288, 8284",
          "Tests 7- Segment display of common cathode & common anode type",
          "Auto search facility of all Digital ICs",
          "40 pin DIP ZIF sockets",
          "28 Keys touch keypad and 9 digit seven segment display.",
          "Home",
          "Analog/Digital Trainer Kits",
          "Basic Communication Trainers",
          "Digital Communication Trainers",
        ],
      },
    ],
  },
  {
    slug: "interface-and-study-cards",
    category: "education",
    title: "Interface & Study Cards",
    products: [
      {
        name: "ADC - 0809 Interfacing Module",
        image: "/products/6629a7_adc-0809-interfacing-module-250x250.jpg",
        description: "",
        bullets: [
          "ADC module using ADC-0809.",
          "8 bit accuracy ADC chip",
          "Eight Channel on-chip multiplexed ADC.",
          "A/D Conversion time 100 micro sec.",
          "SOC, EOC, O/P enable can be accessed by user.",
          "Provision of 0 to 5V variable source using Potentiometer for one channel.",
          "Eight channel analog inputs are to be provided on Screw Terminals.",
          "Connect to 8255 using 26 pin FRC Connector.",
          "User's manual with sample programs.",
        ],
      },
      {
        name: "DAC - 0800 Interfacing Module",
        image: "/products/6eacb4_dac-0800-interfacing-module-250x250.jpg",
        description: "",
        bullets: [
          "DAC module using DAC-0800.",
          "8 bit accuracy DAC chip",
          "Dual channel DAC using 2 Nos. of DAC-0800.",
          "DAC settling time is 100 ns",
          "DAC output is provided at two test points.",
          "Connect to 8255 using 26 pin FRC connector.",
          "User's manual with sample programs.",
        ],
      },
      {
        name: "AD - 574 Interfacing Module",
        image: "/products/cb4061_ad-574-interfacing-module-250x250.jpg",
        description: "",
        bullets: [
          "ADC module using AD-574 chip.",
          "12 bit accuracy ADC chip",
          "Single channel ADC module.",
          "A/D conversion time of 15 micro sec.",
          "Analog inputs are provided at screw terminals.",
          "Connect to 8255 using 26 pin FRC connector.",
          "User's manual with sample programs",
        ],
      },
      {
        name: "Digital I/O Interfacing Module",
        image: "/products/5d752a_digital-i-o-interfacing-module-250x250.jpg",
        description: "",
        bullets: [
          "8 Digital Inputs provided using 8 way DIP Switch",
          "8 Input LED Indicators are provided",
          "8 Output LED Indicators are provided",
          "Connect to 8255 using 26 pin FRC Connector.",
          "User's Manual with Sample Programs.",
        ],
      },
      {
        name: "Elevator Simulator Module",
        image: "/products/3f5954_elevator-simulator-module-250x250.jpg",
        description: "",
        bullets: [
          "Four floor elevator simulator model",
          "LED indication for Each Floor is provided",
          "Up & Down Lift position indication by 10 Nos. of LED",
          "Each Floor is accessed using Four Keys provided on board.",
          "Connect to 8255 using 26 pin FRC Connector.",
          "User's manual with sample programs.",
        ],
      },
      {
        name: "IC Tester IM For IC - 7400",
        image: "/products/26cee3_ic-tester-im-for-ic-7400-250x250.jpg",
        description: "",
        bullets: [
          "On-board two nos. of 14 pin socket and one no. of 16 pin Socket provided.",
          "One 14 Pin IC-7400 IC is provided for testing.",
          "Connect to 8255 using 26 pin FRC Connector.",
          "User's Manual with Sample Programs.",
        ],
      },
      {
        name: "Four Digit Seven Segment Display.",
        image: "/products/e1af40_four-digit-seven-segment-display-250x250.jpg",
        description: "",
        bullets: [
          "Four digit seven segment display.",
          "Display technique used is serial in parallel out shift register technique",
          "For this technique two port pins are used for display.",
          "Connect to 8255 using 26 pin FRC Connector.",
          "User's manual with sample programs.",
        ],
      },
      {
        name: "Stepper Motor Controller Card With Motor",
        image: "/products/5f44a2_stepper-motor-controller-card-with-motor-250x250.jpg",
        description: "",
        bullets: [
          "This Card can Control a Two/Four phase motor",
          "Half Step, Full Step can be controlled using this card.",
          "Clock Wise & Anti Clock wise rotations can be controlled",
          "Speed can be controlled by this controller",
          "Facility to control maximum 2Kg cm Motor is provided.",
          "0.25Kg cm Stepper Motor is supplied along with this module.",
          "Provision for connecting external 5V/12V supply to drive the motor",
          "Connect to 8255 using 26 pin FRC Connector.",
          "User's Manual with Sample Programs.",
        ],
      },
      {
        name: "5x4 Keys Matrix Keyboard Interface Module",
        image: "/products/f391ad_5x4-keys-matrix-keyboard-interface-module-250x250.jpg",
        description: "",
        bullets: [
          "5x4 Keys matrix Keyboard.",
          "Keyboard consists of 20 keys.",
          "Consist of hexadecimal numerals from 0 to 13.",
          "Keys are organized as Four Rows & Five Columns Matrix",
          "Connect to 8255 using 26 pin FRC Connector.",
          "User's manual with sample programs.",
        ],
      },
      {
        name: "6x1 LCD Display Module",
        image: "/products/9592c7_16x1-lcd-display-module-250x250.jpg",
        description: "",
        bullets: [
          "16x1 Liquid Crystal Display.",
          "One 16 rows Alphanumeric Characters will be Displayed.",
          "Facility for back lite display.",
          "Connect to 8255 using 26 pin FRC Connector.",
          "User's manual with sample programs.",
        ],
      },
      {
        name: "16x2 LCD Display Module",
        image: "/products/aa641c_16x2-lcd-display-module-250x250.jpg",
        description: "",
        bullets: [
          "16x2 Liquid Crystal Display.",
          "Two 16 rows alphanumeric characters will be displayed.",
          "Facility for back lite display.",
          "Connect to 8255 using 26 pin FRC Connector.",
          "User's manual with sample programs.",
        ],
      },
      {
        name: "Traffic Light Controller Module",
        image: "/products/ec83f2_traffic-light-control-module-250x250.jpg",
        description: "",
        bullets: [
          "Single Square traffic light display controller",
          "East, west, north, south posts are defined on the PCB for the square.",
          "For each post four LED is provided in Red, Yellow & Green color.",
          "Connect to 8255 using 26 pin FRC Connector.",
          "User's manual with sample programs.",
        ],
      },
      {
        name: "Temperature Measurement Module",
        image: "/products/fdb31f_temperature-measurement-module-250x250.jpg",
        description: "",
        bullets: [
          "ADC-0809 is used for analog to digital conversion.",
          "8 bit accuracy ADC chip",
          "A/D Conversion time is 100 micro sec.",
          "Op-amps are provided for signal conditioning of output from sensor.",
          "K-type thermocouple is used for the measurement.",
          "Thermocouple sensor is supplied with the module.",
          "Variable pot is provided for adjusting gain and offset.",
          "Temperature measurement max. up to 99°C is possible",
          "Connect to 8255 using 26 pin FRC Connector.",
          "User's Manual with Sample Programs.",
        ],
      },
      {
        name: "DC Motor Controller Card With Motor",
        image: "/products/b4eb62_dc-motor-controler-card-with-module-250x250.jpg",
        description: "",
        bullets: [
          "DAC-0800 is used for digital to analog conversion.",
          "8 bit accuracy DAC chip",
          "SPDT Relay is provided for direction control",
          "Clock Wise & Anti Clock wise rotation can be controlled",
          "Speed can be controlled by this controller",
          "9 Volt DC Motor is supplied with this card.",
          "9 Volt AC Adaptor is supplied with this card.",
          "Connect to 8255 using 26 pin FRC Connector.",
          "User's manual with sample programs.",
        ],
      },
      {
        name: "Relay And OPTO Coupler Interfacing Module",
        image: "/products/21c12a_relay-and-opto-coupler-interfacing-module-250x250.jpg",
        description: "",
        bullets: [
          "Four SPDT Relays are provided.",
          "Relay outputs NO, NC, COM is provided at Screw Terminals.",
          "Four Opto isolator inputs are provided using MCT2E.",
          "Opto Inputs are provided through 10 pin FRC Connector.",
          "Connect to 8255 using 26 pin FRC Connector.",
          "User's manual with sample programs.",
        ],
      },
      {
        name: "8x8 LED Matrix Interfacing Module",
        image: "/products/93f628_8x8-led-matrix-interfacing-module-250x250.jpg",
        description: "",
        bullets: [
          "8x8 LED Matrix Display.",
          "Display consists of 64 nos. of 3mm LED.",
          "LED’s are organized as Eight Rows & Eight Columns matrix.",
          "All LEDs are buffered.",
          "Connect to 8255 using 26 pin FRC Connector",
          "User's manual with sample programs.",
        ],
      },
      {
        name: "Thumb Wheel Switch Card",
        image: "/products/4da81a_thumb-wheel-switch-card-250x250.jpg",
        description: "",
        bullets: [
          "Two digit thumb wheel switch.",
          "Thumb wheel switch can be set from 00 to 99.",
          "Output of Thumb wheel switch is in BCD format.",
          "Connect to 8255 using 26 pin FRC connector.",
          "User's manual with sample programs.",
        ],
      },
      {
        name: "Light Sensing Module Using LDR",
        image: "/products/6ea81a_light-sensing-module-using-ldr-250x250.jpg",
        description: "",
        bullets: [
          "Light Sensing device using LDR",
          "For Alarm indication one SPDT Relay is provided.",
          "Relay output is provided in connector.",
          "Connect to 8255 using 26 pin FRC Connector.",
          "User's manual with sample programs.",
        ],
      },
      {
        name: "OPTO Isolated Input Module",
        image: "/products/e02911_opto-isolated-input-module-250x250.jpg",
        description: "",
        bullets: [
          "8 bit OPTO Isolated input using MCT-2E IC.",
          "OPTO inputs indication are provided by 5mm LED.",
          "OPTO inputs are provided through 16 pin Connector.",
          "Connect to 8255 using 26 pin FRC Connector.",
          "User's manual with sample programs.",
        ],
      },
      {
        name: "OPTO Isolated Output Module",
        image: "/products/72c790_opto-isolated-output-module-250x250.jpg",
        description: "",
        bullets: [
          "8 bit OPTO Isolated output using MCT-2E IC.",
          "OPTO outputs indication are provided by 5mm LED.",
          "OPTO output are provided through 16 pin Connector",
          "External +12V provision is provided for isolation.",
          "Connect to 8255 using 26 pin FRC Connector.",
          "User's Manual with Sample Programs",
        ],
      },
      {
        name: "101 ASC II Keyboard Module",
        image: "/products/bcc665_101-asc-ii-keyboard-module-250x250.jpg",
        description: "",
        bullets: [
          "101 ASCII PC Keyboard interface.",
          "PC Keyboard interface through 89c2051 Microcontroller.",
          "PC Keyboard AT-type Connector is provided",
          "101 ASCII keyboard is provided with this module.",
          "Connect to 8255 using 26 pin FRC Connector.",
          "User's Manual with Sample Programs.",
        ],
      },
      {
        name: "Real Time Clock (RTC - 6242) Module",
        image: "/products/e5d3fc_real-time-clock-rtc-6242-module-250x250.jpg",
        description: "",
        bullets: [
          "Real Time Clock using IC 6242.",
          "32.678 KHz. Crystal is provided.",
          "Date, month & year can be measured.",
          "Seconds, minutes & hours can be measured.",
          "Connect through 40/50 pin FRC Connector.",
          "User's manual with sample programs.",
        ],
      },
      {
        name: "Seven Segment Display With Matrix Keyboard",
        image: "/products/1c1370_seven-segment-display-with-matrix-keyboard-250x250.jpg",
        description: "",
        bullets: [
          "5x4 Keys matrix Keyboard.",
          "Keyboard consists of 20 keys.",
          "Consist of Hexadecimal numerals from 0 to 13.",
          "Keys are organized as Four Rows & Five Columns matrix",
          "Study of techniques like software debouching, Keyboard scanning, key closer, two keys lockout, keyboard encoding & Pausing.",
          "16x2 Liquid Crystal Display.",
          "Two 16 rows alphanumeric characters will be displayed.",
          "Facility for backlite display.",
          "Connect to 8255 using 26 pin FRC Connector.",
          "User's Manual with Sample Programs.",
        ],
      },
      {
        name: "16x2 LCD Display With Matrix Keyboard",
        image: "/products/d78c35_16x2-lcd-display-with-matrix-keyboard-250x250.jpg",
        description: "",
        bullets: [
          "5x4 Keys matrix Keyboard.",
          "Keyboard consists of 20 keys.",
          "Consist of Hexadecimal numerals from 0 to 13.",
          "Keys are organized as four rows & five columns matrix",
          "Study of techniques like software debouching, keyboard scanning, key closer, two keys lockout, keyboard encoding & Pausing.",
          "16x2 Liquid Crystal Display.",
          "Two 16 rows alphanumeric characters will be displayed.",
          "Facility for back lite display.",
          "Connect to 8255 using 26 pin FRC Connector.",
          "User's manual with sample programs",
        ],
      },
      {
        name: "Bit AD / DA Interfacing Module",
        image: "/products/0f8a8c_8-bit-ad-da-interfcing-module-250x250.jpg",
        description: "",
        bullets: [
          "ADC module using ADC-0804.",
          "8 bit accuracy ADC chip",
          "Single Channel ADC.",
          "A/D Conversion time 100 micro sec.",
          "Single Channel DAC using one No. of DAC-0800",
          "8 bit accuracy DAC chip",
          "DAC Settling time is 100 ns",
          "Analog inputs and outputs are provided on Screw Terminals.",
          "Connect to 8255 using 26 pin FRC Connector.",
          "User's Manual with Sample Programs.",
        ],
      },
      {
        name: "Level Simulator Module",
        image: "/products/39e018_level-simulator-module-250x250.jpg",
        description: "",
        bullets: [
          "Four Level Simulator model",
          "Level indication is provided using LED",
          "Up & Down Level position indication by 10 Nos. of LED",
          "Lower & upper level limit can be set by software",
          "Connect to 8255 using 26 pin FRC Connector.",
          "User's manual with sample programs.",
        ],
      },
      {
        name: "Six Digit Seven Segment Display Module",
        image: "/products/3100f0_six-digit-seven-segment-display-module-250x250.jpg",
        description: "",
        bullets: [
          "On-board six digit seven segment display.",
          "Display technique used is Decoder technique",
          "For this technique two port pins are used for display.",
          "Connect to 8255 using 26 pin FRC Connector.",
          "User's Manual with Sample Programs.",
        ],
      },
      {
        name: "Parellel To Serial And Serial To Parallel Module",
        image: "/products/a57d3f_parellel-to-serial-and-serial-to-parellel-module-250x250.jpg",
        description: "",
        bullets: [
          "8 bit Parallel to serial convertor using IC-74165.",
          "Eight Parallel Inputs are indicated by LED.",
          "Serial to 8 bit parallel convertor using IC-74595.",
          "Eight Parallel Outputs are indicated by LED.",
          "Connect to 8255 using 26 pin FRC Connector.",
          "User's manual with sample program.",
        ],
      },
      {
        name: "8255 Programmable Peripheral Interface Study Card",
        image: "/products/b11ac5_8255-programmable-peripheral-intrerface-study-card-250x250.jpg",
        description: "",
        bullets: [
          "24 bit I/O using 8255 Programmable Peripheral IC",
          "All Input/Output ports pins are terminated on 3 eight pin terminals and 26 pin FRC Connector",
          "All Input/Output ports are indicated by 3 mm LED.",
          "Data lines from AD0 to AD7 are indicated by 3 mm LED.",
          "Chip Select, A0, A1, Read, Write are indicated by 3 mm LED.",
          "Hardware Single Step and Full Clock Execution mode are provided.",
          "Single stepping can be performed using micro switch provided on board.",
          "Using this study card all MODE experiment can be performed.",
          "Interface 8085/8086 Kit using 50 pin FRC Connector.",
          "User's Manual with Sample Programs.",
        ],
      },
      {
        name: "8253 Programmable Timer Counter Study Card",
        image: "/products/208653_8253-programmable-timer-counter-study-card-250x250.jpg",
        description: "",
        bullets: [
          "Three channel Timer/Counter using 8253 Programmable Timer Counter IC.",
          "All Input/Output ports pins are terminated on terminals and 10 pin FRC Connector.",
          "Clock for Counter-0 is internally provided.",
          "Data lines from AD0 to AD7 are indicated by 3 mm LED.",
          "Chip Select, A0, A1, Read, Write are indicated by 3 mm LED.",
          "Hardware Single Step and Full Clock Execution modes are provided.",
          "Single stepping can be performed using micro switch provided on board.",
          "Using this study card all MODE experiment can be performed.",
          "Interface 8085/8086 Kit using 50 pin FRC Connector.",
          "User's Manual with Sample Programs.",
        ],
      },
      {
        name: "8155 Programmable Peripheral Interface With Timer",
        image: "/products/aa8cfb_8155-programmable-peripheral-interface-with-timer-250x250.jpg",
        description: "",
        bullets: [
          "22 bit I/O with single channel timer using 8155 Programmable Peripherals IC",
          "All Input/Output ports pins are terminated on 3 eight pin terminals and 26 pin FRC Connector",
          "All Input/Output ports are indicated by 3 mm LED.",
          "Data lines from AD0 to AD7 are indicated by 3 mm LED.",
          "Chip Select, IO, Memory, Read, Write are indicated by 3 mm LED.",
          "Hardware Single Step and Full Clock Execution modes are provided.",
          "Single stepping can be performed using micro switch provided on board.",
          "Using this study card all MODE experiment can be performed.",
          "Interface 8085/8086 Kit using 50 pin FRC Connector.",
          "User's Manual with Sample Programs.",
        ],
      },
      {
        name: "8251 USART Study Card",
        image: "/products/a73f69_8251-ustart-study-card-250x250.jpg",
        description: "",
        bullets: [
          "22 bit I/O with single channel timer using 8155 Programmable Peripherals IC",
          "All Input/Output ports pins are terminated on 3 eight pin terminals and 26 pin FRC Connector",
          "All Input/Output ports are indicated by 3 mm LED.",
          "Data lines from AD0 to AD7 are indicated by 3 mm LED.",
          "Chip Select, IO, Memory, Read, Write are indicated by 3 mm LED.",
          "Hardware Single Step and Full Clock Execution modes are provided.",
          "Single stepping can be performed using micro switch provided on board.",
          "Using this study card all MODE experiment can be performed.",
          "Interface 8085/8086 Kit using 50 pin FRC Connector.",
          "User's Manual with Sample Programs.",
        ],
      },
      {
        name: "8257 Direct Memory Access Study Card",
        image: "/products/1ff920_8257-direct-memory-access-study-card-250x250.jpg",
        description: "",
        bullets: [
          "Programmable Direct Memory Access controller using 8257 IC.",
          "On-board 2K RAM Provided using 6116 IC for DMA Operation.",
          "8 Inputs are fed through input terminals with 3 mm LED indicator.",
          "Data lines from AD0 to AD7 are indicated by 3mm LED.",
          "Chip Select, Read, Write, A0, A1, A2, A3, Memory-Write,",
          "Memory-Read, IO-Write, IO-Read are indicated by 3mm LED.",
          "AEN, Mark, TC, HRQ, DACK0, DACK1, DACK2 are indicated by 3 mm LED.",
          "Hardware Single Step and Full Clock Execution modes are provided.",
          "Single stepping can be performed using micro switch provided on board.",
          "Using this study card all MODE experiment can be performed.",
          "Interface 8085/8086 Kit using 50 pin FRC Connector.",
          "User's Manual with Sample Programs..",
        ],
      },
      {
        name: "8259 Programmable Interrupt Controller Study Card",
        image: "/products/9bfa90_sc-06-8259-programmable-interrupt-controller-study-card-250x250.jpg",
        description: "",
        bullets: [
          "8 Channel Programmable Interrupt Controller using 8259 IC.",
          "8 Inputs interrupts are fed through input terminals.",
          "Data lines from AD0 to AD7 are indicated by 3 mm LED.",
          "Chip Select, Read, Write, INTA, INTR are indicated by 3 mm LED.",
          "Hardware Single Step and Full Clock Execution modes are provided.",
          "Single stepping can be performed using micro switch provided on board.",
          "Using this study card all MODE experiment can be performed.",
          "Interface 8085/8086 Kit using 50 pin FRC Connector.",
          "User's Manual with Sample Programs.",
        ],
      },
      {
        name: "8279 PKDC Study Card",
        image: "/products/b3ac84_8279-pkdc-study-card-250x250.jpg",
        description: "",
        bullets: [
          "Programmable Keyboard Display Controller using 8279 IC.",
          "All scan lines/return lines are fed through input terminals and 26 pin FRC connector.",
          "Data lines from AD0 to AD7 are indicated by 3 mm LED.",
          "Chip Select, Read, Write, INTA, A0 are indicated by 3 mm LED.",
          "Hardware Single Step and Full Clock Execution mode are provided.",
          "Single stepping can be performed using micro switch provided in the board.",
          "8 Digit Seven Segment display with 20 keys keypad interface module can be interfaced with 8279 Study Card. (Optional)",
        ],
      },
      {
        name: "(Optional)",
        image: "",
        description: "",
        bullets: [
          "Using this study card all modes experiment can be performed.",
          "Interface 8085/8086 Kit using 50 pin FRC Connector.",
          "User's Manual with Sample Program.",
        ],
      },
      {
        name: "8212 Latch Study Card",
        image: "/products/5d803d_8212-latch-study-card-250x250.jpg",
        description: "",
        bullets: [
          "Eight bit Latch output using 8212 IC",
          "Eight buffered latched output are indicated by 3 mm LED.",
          "Hardware Single Step and Full Clock Execution modes are provided.",
          "Single stepping can be performed using micro switch provided on board.",
          "Using this study card all MODE experiment can be performed.",
          "Interface 8085/8086 Kit using 50 pin FRC Connector.",
          "User's Manual with Sample Programs.",
        ],
      },
      {
        name: "Latch / Buffer Study Card",
        image: "/products/4c01e7_latch-buffer-study-card-250x250.jpg",
        description: "",
        bullets: [
          "8 bit Latch output using 74373 IC.",
          "8 bit Buffer input using 74245 IC.",
          "8 buffered latch output are indicated by 3 mm LED.",
          "Eight Way DIP Switch is provided for buffer input.",
          "Eight bit buffered output are indicated by 3 mm LED.",
          "Chip Select for IC-74245 and IC-74373 are indicated by 3 mm LED.",
          "Hardware Single Step and Full Clock Execution modes are provided.",
          "Single stepping can be performed using micro switch provided on board.",
          "Using this study card all MODE experiment can be performed.",
          "Interface 8085/8086 Kit using 50 pin FRC Connector.",
          "User's Manual with Sample Programs.",
        ],
      },
      {
        name: "6116/6264/32256 Ram Study Card",
        image: "/products/ccffb6_6116-6264-32256-ram-study-card-250x250.jpg",
        description: "Interface and Study Cards",
        bullets: [
          "Random access memory using 6264 IC.",
          "Data lines from AD0 to AD7 are indicated by 3 mm LED.",
          "Chip Select, Read, Write are indicated by 3 mm LED.",
          "Hardware single step and full clock execution modes are provided.",
          "Single stepping can be performed using micro switch provided on board.",
          "Using this study card all MODE experiment can be performed.",
          "Interface 8085/8086 Kit using 50 pin FRC Connector.",
          "User's Manual with Sample Programs.",
          "Home",
          "Analog/Digital Trainer Kits",
        ],
      },
    ],
  },
  {
    slug: "microprocessor-trainers",
    category: "education",
    title: "Microprocessor Trainers",
    products: [
      {
        name: "8085-Microprocessor Trainer (LED-VER) - 01",
        image: "/products/6d1f1a_m85-01-8085-microprocessor-trainer-led-ver-250x250.jpg",
        description: "",
        bullets: [
          "Based on 8085 CPU operating at 6.144 MHz.",
          "88KB of RAM with Battery Backup, 8K Monitor EPROM",
          "Peripheral like 8255,8253, RS-232 using SID/SOD lines",
          "28 keys keyboard with six 7- segment display using 8279",
          "In-Built Power Supply of +5V/1.5A, ±12V/250mA",
        ],
      },
      {
        name: "8085-Microprocessor Trainer (LED-VER) - 02",
        image: "/products/26bdc2_m85-02-8085-microprocessor-trainer-led-ver-250x250.jpg",
        description: "",
        bullets: [
          "Based on 8085 CPU operating at 6.144 MHz.",
          "88KB of RAM with battery backup, 8K Monitor EPROM",
          "Peripheral like 8255,8253, RS-232 using SID/SOD lines",
          "28 keys keyboard with six 7- segment display using 8279",
          "In-Built Power Supply of +5V/1.5A, ±12V/250mA",
        ],
      },
      {
        name: "8085-Microprocessor Trainer (LED-VER) - 03",
        image: "/products/ea19f1_m85-03-8085-microprocessor-trainer-led-ver-250x250.jpg",
        description: "",
        bullets: [
          "Based on 8085 CPU operating at 6.144 MHz.",
          "88KB of RAM with battery backup, 8K Monitor EPROM",
          "Peripheral like 8255, 8253, RS-232 using SID/SOD lines",
          "28 keys keyboard with six 7- segment display using 8279",
          "In-Built Power Supply of +5V/1.5A, ±12V/250mA",
        ],
      },
      {
        name: "8085-Microprocessor Trainer (LED-VER) - 04",
        image: "/products/4eac40_m85-04-8085-microprocessor-trainer-led-ver-250x250.jpg",
        description: "",
        bullets: [
          "Based on 8085 CPU operating at 6.144 MHz.",
          "8KB of RAM with battery backup, 8K Monitor EPROM",
          "Peripheral like 2X 8255,8253, RS-232 using SID/SOD lines",
          "20x2 Alphanumeric LCD Display with Backlite with 101 ASCII Keyboard",
          "On board Single Line Assembler / Disassembler",
          "In-Built Power Supply of +5V/1.5A, ±12V/250mA",
        ],
      },
      {
        name: "8085-Advance-Microprocessor Trainer (LED-VER)",
        image: "/products/19e1e7_m85-07-8085-adv-microprocessor-trainer-led-ver-250x250.jpg",
        description: "Microprocessor Trainers",
        bullets: [
          "Based on 8085 CPU operating at 6.144 MHz.",
          "8KB of RAM with battery backup, 8K Monitor EPROM",
          "Peripheral like 2X 8255, 8253, 8259, 8251, RS-232 using SID/SOD lines",
          "On-board Eprom Programmer, ADC0809, DAC0800, Relay, OPTO, Printer interface",
          "20x2 Alphanumeric LCD Display with Backlite with 101 ASCII Keyboard",
          "On board Single Line Assembler / Disassembler",
          "In-Built Power Supply of +5V/1.5A, ±12V/250mA",
          "Home",
          "Analog/Digital Trainer Kits",
          "Basic Communication Trainers",
        ],
      },
    ],
  },
  {
    slug: "vlsi-trainers",
    category: "education",
    title: "VLSI Trainers",
    products: [
      {
        name: "Universal VLSI Trainer - 01",
        image: "/products/8249c2_universal-vlsi-trainer-250x250.jpg",
        description: "",
        bullets: [
          "Piggy Bag Modules compatible of XILINX 9572 CPLD , 95108 CPLD, SPARTAN XC3S50 FPGA and XC3S400 FPGA",
          "16 Toggle Input Switch and 16 output with LED indication",
          "Onboard 4 Digit Seven Segment display,16x1 LCD and 4x4 Matrix Keyboard",
          "On-board ISP Programmer for Piggy Bag Modules",
          "Clock generator generating 10MHz, 5MHz, 1MHz, 100 KHz & 100 Hz.",
          "In-Built Power Supply of +5V/1.5A, ±12V/250mA",
        ],
      },
      {
        name: "Universal VLSI Trainer - 02",
        image: "/products/1c69a9_vls-04-universal-vlsi-trainer-250x250.jpg",
        description: "",
        bullets: [
          "Piggy bag modules compatible of XILINX SPARTAN XC3S50 FPGA & XC3S400 FPGA",
          "16 Toggle Input Switch and 16 output with LED indication",
          "Onboard 4 digit seven segment display, PS/2 port, VGA port, RS-232 port.",
          "On-board ISP programmer for piggy bag modules",
          "Clock generator generating 10MHz, 5MHz, 1MHz, 100 KHz & 100 Hz.",
          "In-Built power Supply of +5V/1.5A, ±12V/250mA",
          "Home",
          "Analog/Digital Trainer Kits",
          "Basic Communication Trainers",
          "Digital Communication Trainers",
        ],
      },
    ],
  },
  {
    slug: "analog-communication-trainer",
    category: "education",
    title: "Analog Communication Trainer",
    products: [
      {
        name: "DSB-SSB-AM - Transmitter Kit",
        image: "/products/04c67f_act-08-dsb-ssb-am-transmitter-kit-250x250.jpg",
        description: "",
        bullets: [
          "Internal 300Hz to 3.4KHz Sinewave generator.",
          "2 Nos. of balanced modulator with band pass filter (1MHz) & 1 No. of balanced modulator (455KHz).",
          "Ceramic band pass filter, Carrier Frequency of 1MHz.",
          "Audio output amplifier with speaker.",
        ],
      },
      {
        name: "DSB-SSB-AM - Receiver Kit",
        image: "/products/47f653_act-09-dsb-ssb-am-receiver-kit-250x250.jpg",
        description: "",
        bullets: [
          "Frequency range of 525 to 1625Khz.",
          "Receiver CKT consist of RF amplifier, mixer, local oscillator, BFO, IF amplifier-1, IF amplifier-2.",
          "Diode detector for DSB & Product detector for SSB.",
          "Audio output amplifier with Speaker.",
        ],
      },
      {
        name: "FM - Transmiter- Receiver Kit",
        image: "/products/f99b97_act-10-fm-transmiter-receiver-kit-250x250.jpg",
        description: "",
        bullets: [
          "Internal 300Hz to 3.4KHz sinewave generator.",
          "FM Modulation using reactance Modulator & Varactor Modulator.",
          "Transmitter Frequency to 455 KHz.",
          "FM Demodulator using detuned Resonant detector, Quadrature detector.",
          "Fooster seeley detector, Ratio detector & PLL detector.",
          "Low Pass filter with cut off frequency of 3.4KHz.",
        ],
      },
      {
        name: "Frequency Division MUX-DE-MUX- Trainer",
        image: "/products/ee6103_act-11-frequency-division-mux-de-mux-trainer-250x250.jpg",
        description: "",
        bullets: [
          "Two nos. of sine wave generators provided.",
          "Provision for amplitude & frequency adjustments provided.",
          "Fixed sine wave generators of 100 KHz and 200 KHz.",
          "Two Nos. of DSB-SC modulator with summing amplifier provided.",
          "Two Nos. of balanced de-modulator.",
        ],
      },
      {
        name: "Transmission Line Trainer",
        image: "/products/238c94_act-13-transmission-line-trainer-250x250.jpg",
        description: "Analog Communication Trainers",
        bullets: [
          "Coaxial cables transmission lines 100 m (25m x 4 nos.).",
          "Impedance matching resistance of 0 to 100 (2 nos.).",
          "4 KHz to 4 MHz. sine wave generator.",
          "10 KHz square wave generator.",
          "Home",
          "Analog/Digital Trainer Kits",
          "Basic Communication Trainers",
          "Digital Communication Trainers",
          "Embedded Development Board",
          "Eprom Programmer",
        ],
      },
    ],
  },
  {
    slug: "fibre-optic-communication-trainers",
    category: "education",
    title: "Fibre Optic Communication Trainers",
    products: [
      {
        name: "Fiber Optics Trainer - 01",
        image: "/products/52a69c_fiber-optics-trainer-250x250.jpg",
        description: "",
        bullets: [
          "One 660 nm FO LED Transmitter and One FO photo detector Receivers.",
          "On-board Sine wave generator 1Hz to 10Khz.",
          "Analog & Digital Transmission & Reception.",
          "350 KHz Analog and 2.5 KHz Digital Band Width.",
          "RS-232 communication with PC.",
          "Voice Link using microphone &speaker.",
        ],
      },
      {
        name: "Fiber Optics Trainer - 02",
        image: "/products/4ea813_fiber-optics-trainer-250x250.jpg",
        description: "",
        bullets: [
          "One 660 NM & 950 NM FO LED Transmitter and Two FO photo detector Receivers.",
          "On-board Sine wave generator 1Hz to 10Khz.",
          "Analog & Digital Transmission & Reception.",
          "350 KHz Analog and 2.5 KHz Digital Band Width.",
          "350 KHz Analog and 2.5 KHz Digital Band Width.",
          "AM, FM, PWM, PPM modulation & demodulation",
          "Voice Link using microphone &speaker.",
        ],
      },
      {
        name: "Advanced Fiber Optics Trainer",
        image: "/products/a6605b_advanced-fiber-optics-trainer-250x250.jpg",
        description: "",
        bullets: [
          "One 660 nm FO LED transmitter and Two FO photo detector Receivers.",
          "On-board Sine wave generator 1Hz to 10Khz.",
          "Analog & digital transmission & reception.",
          "350 KHz Analog and 5 KHz Digital Band Width.",
          "6 channel TDM Modulation Techniques using PCM CODEC Chip",
          "RS-232 communication with PC",
          "CODEC Link using Two Telephone Hand set provided",
        ],
      },
      {
        name: "Laser Fiber Optics Trainer",
        image: "/products/618c19_laser-fiber-optics-trainer-250x250.jpg",
        description: "Fiber Optic Communication Trainers",
        bullets: [
          "660nm laser diode transmitter and photo detector receiver",
          "On-board sine wave generator 1Hz to 10Khz.",
          "GI/MM glass fiber cable of 2M",
          "Analog & digital transmission & reception.",
          "RS-232 communication with PC",
          "Home",
          "Analog/Digital Trainer Kits",
          "Basic Communication Trainers",
          "Digital Communication Trainers",
          "Embedded Development Board",
        ],
      },
    ],
  },
  {
    slug: "instrumentation-trainer",
    category: "education",
    title: "Instrumentation Trainer",
    products: [
      {
        name: "Displacement Measurement Using LVDT",
        image: "/products/498896_displacement-measurement-using-lvdt-250x250.jpg",
        description: "",
        bullets: [
          "LVDT Transducer with Displacement of ± 5mm transparent enclosure.",
          "Primary Excitation voltage of Sine wave 1V p-p",
          "On-board Digital Panel Meter provided.",
          "Output available on 2mm Banana sockets for monitoring.",
        ],
      },
      {
        name: "Pressure Measurement Kit",
        image: "/products/55cb8b_pressure-measurement-kit-250x250.jpg",
        description: "",
        bullets: [
          "Resistive pressure transducer with pressure of 0-300mm HG/ 6PSI transparent enclosure.",
          "Primary excitation voltage of 5V DC.",
          "On-board digital panel meter provided.",
          "Output available on 2mm banana sockets for monitoring.",
        ],
      },
      {
        name: "Load Measurement Using Strain Gauge Kit",
        image: "/products/bdcbf4_load-measurement-using-strain-guage-kit-250x250.jpg",
        description: "",
        bullets: [
          "Resistive load cell is used to measure load up to 3 kgs.",
          "Primary excitation voltage of 12V DC.",
          "On-board digital panel meter provided.",
          "Output available on 2mm banana sockets for monitoring.",
        ],
      },
      {
        name: "Temperature Measure Using Thermocouple",
        image: "/products/9e5a52_temperature-measure-using-thromocopuple-250x250.jpg",
        description: "",
        bullets: [
          "K-type Thermocouple is used to measure up to 100°C",
          "On-board digital panel meter provided.",
          "Thermometer for measurement of temperature",
          "Output available on 2mm Banana sockets for Monitoring.",
        ],
      },
      {
        name: "Temperature Measurement Using RTD (PT - 100)",
        image: "/products/159896_temperature-measurement-using-rtd-pt-100-250x250.jpg",
        description: "",
        bullets: [
          "PT-100 Type RTD sensor is used to measure up to 100°C",
          "On-board Digital panel meter provided.",
          "Thermometer for measurement of temperature",
          "Output available on 2mm Banana sockets for Monitoring.",
        ],
      },
      {
        name: "LDR / Photo - Transistor Trainer Kit",
        image: "/products/db85e5_ldr-photo-transistor-trainer-kit-250x250.jpg",
        description: "",
        bullets: [
          "LDR or Photo-Transistor is used for light sensing.",
          "Output available on 2mm Banana sockets for Monitoring.",
          "Relay output for alarm indication",
        ],
      },
      {
        name: "Level Indicator Kit",
        image: "",
        description: "",
        bullets: [
          "Capacitive Level Transducer to measure Level Measurement up to 150mm.",
          "On-board Digital Panel Meter provided.",
          "Onboard Instrumentation Amplifier provided",
          "Output available on 2mm Banana sockets for Monitoring.",
        ],
      },
      {
        name: "Speed Measurement Kit",
        image: "",
        description: "",
        bullets: [
          "Magnetic Pick-up Transducer is used.",
          "Photo Pick up Transducer is also used.",
          "On-board Digital Panel Meter provided to measure RPM",
          "6V DC Motor with necessary attachment for measurement is provided",
          "Output available on 2mm Banana sockets for Monitoring.",
        ],
      },
      {
        name: "Angular Displacement Kit",
        image: "/products/b0e062_angular-displacement-kit-250x250.jpg",
        description: "",
        bullets: [
          "Resistive transducer using multi turn potentiometer to measure angular of 0° to 360°.",
          "On-board Digital Panel Meter provided",
          "Protractor for angle measurement",
          "Output available on 2mm Banana sockets for Monitoring.",
        ],
      },
      {
        name: "Thermistor / AD 590 Kit",
        image: "/products/2c23c1_imag.jpg",
        description: "Instrumentation Trainer",
        bullets: [
          "AD590 & Thermistor Sensor is used to measure Temperature up to 100°C.",
          "On-board Digital Panel Meter provided",
          "On board Instrumentation Amplifier provided",
          "Output available on 2mm Banana sockets for Monitoring.",
          "Home",
          "Analog/Digital Trainer Kits",
          "Basic Communication Trainers",
          "Digital Communication Trainers",
          "Embedded Development Board",
          "Eprom Programmer",
        ],
      },
    ],
  },
  {
    slug: "power-supply",
    category: "education",
    title: "Power Supply",
    products: [
      {
        name: "Power Supply",
        image: "/products/961f26_kps-3202power-supply-250x250.jpg",
        description: "",
        bullets: [
          "Output range single/dual variable 0-30 V/2A.",
          "Facility to preset both voltage and current limit desired by the user before DC output is turned on",
          "CV/CC indicted by LED's",
          "Automatic overload and short circuit protection.",
          "Two output meters to read Voltage and Current.",
          "Home",
          "Analog/Digital Trainer Kits",
          "Basic Communication Trainers",
          "Digital Communication Trainers",
          "Embedded Development Board",
        ],
      },
    ],
  },
  {
    slug: "industrial",
    category: "industrial",
    title: "Industrial Components",
    products: [
      {
        name: "Industrial Components",
        image: "/products/2c23c1_imag.jpg",
        description: "",
        bullets: [
          "Analog/Digital Trainer Kits",
          "Basic Communication Trainers",
          "Digital Communication Trainers",
          "Eprom Programmer",
          "VLSI Trainers",
          "Analog Communication Trainer",
          "Fibre Optic Communication Trainers",
        ],
      },
    ],
  },
  {
    slug: "entrance-automation",
    category: "automation",
    title: "Entrance Automation",
    products: [
      {
        name: "SLIDING GATES",
        image: "",
        description: "",
        bullets: [
          "Complete range of models from light residential gates to heavy industrial gates.",
          "Advanced motors with built-in thermal protection, automatically adapt the motor power to \n\nthe climatic conditions.",
          "Intelligent and safe with obstacle detection system and automatic programming of working \n\ntime. Gradual acceleration at the start and Desclaration at the stop ensure a smooth operation without jerks.",
          "Easy to use manual override mechanism incase of power failure.",
          "Very quite in operation.",
        ],
      },
      {
        name: "SWING GATES",
        image: "",
        description: "",
        bullets: [
          "Complete range of models for automating swing gates from light weight to heavy, for \n\nresidential to industrial use. From normal gates to gates with large pillars. Underground versions for ornamental gates.",
          "Reliable and noiseless operation due to fewer moving components and patented internal \n\nlayout design.",
          "Intelligent and safe with obstacle detection system and smooth gradual start and stop \n\nfunction.",
          "Easy to use manual override mechanism incase of power failure.",
        ],
      },
      {
        name: "BARRIERS",
        image: "",
        description: "",
        bullets: [
          "Complete range of models for private, public and industrial car parks. Boom lengths from \n\n3m up to 6m.",
          "Powerful and quick in operation.",
          "Ingenious synchronization of two barriers with master/slave selection facilitates \n\nautomation of entries up to 12m.",
          "Intelligent and safe with obstacle detection system. Acceleration and deceleration at the \n\nbeginning and end of each opening and closing maneuver.",
          "Sophisticated control with revolutionary force, speed and deceleration management \n\nsystem.",
          "Compatible with all access control systems.",
          "Reliable and sturdy.",
          "Designed for intensive use.",
          "Easy to use manual override mechanism in case of power failure.",
        ],
      },
      {
        name: "ROLLING SHUTTER",
        image: "",
        description: "",
        bullets: [
          "Wide range of models from central motors to tubular motors, for smaller spring balanced \n\nrolling shutters to side motors for heavy industrial shutters.",
          "Smart and fast adjustment of limit switches both during opening and closing.",
          "Easy to install due to the guided connector. No need to hold the motor while securing it \n\nwith screws.",
          "Innovative design completely protecting the limit switches assembly and wiring by an \n\nelegant case.",
          "Intelligent motor with built-in thermal protection.",
          "Easy to use manual override mechanism in case of power failure.",
          "Home",
          "Analog/Digital Trainer Kits",
          "Basic Communication Trainers",
          "Digital Communication Trainers",
        ],
      },
    ],
  },
  {
    slug: "automation",
    category: "automation",
    title: "Automation",
    products: [
      {
        name: "Remote Control Doors",
        image: "/products/20e169_rf-id-tag-systems-250x250.jpg",
        description: "",
        bullets: [
        ],
      },
      {
        name: "RF-ID/ TAG Systems",
        image: "/products/6704dc_key-pad-locking-system-doors-250x250.jpg",
        description: "",
        bullets: [
        ],
      },
      {
        name: "Key Pad Locking System Doors",
        image: "/products/070495_modular-system-250x250.jpg",
        description: "",
        bullets: [
        ],
      },
      {
        name: "Modular Control System",
        image: "/products/d25720_a-i-r-sensors-250x250.jpg",
        description: "",
        bullets: [
        ],
      },
      {
        name: "A.I.R Sensors.",
        image: "/products/b16366_access-control-doors-250x250.jpg",
        description: "",
        bullets: [
          "Access Control Doors We have created a niche in the industry by offering a quality sorted range of Access Control Doors for our valued customers. This range o r products is manufactured by making use of latest technological equipment, tools and techniques. These doors are used to stop false entries in restricted areas and mark attendance in factories, offices and corporate houses.",
        ],
      },
      {
        name: "Access Control Doors",
        image: "/products/afc01f_access-control-systems-250x250.jpg",
        description: "",
        bullets: [
        ],
      },
      {
        name: "Access Control Systems",
        image: "/products/68c628_biometric-lock-system-250x250.jpg",
        description: "",
        bullets: [
        ],
      },
      {
        name: "Biometric Lock Systems.",
        image: "/products/c5146a_biometric-solutions-250x250.jpg",
        description: "",
        bullets: [
          "Biometric Solutions We bring forth a wide array of Biometric Solutions to meet the demands and desires of our valued customers. These products are a perfect exemplification of exceptional skill and talent of our qualified professionals.",
        ],
      },
      {
        name: "Biometric Solutions",
        image: "/products/2c23c1_imag.jpg",
        description: "",
        bullets: [
          "Home",
          "Analog/Digital Trainer Kits",
          "Basic Communication Trainers",
          "Digital Communication Trainers",
          "Embedded Development Board",
          "Eprom Programmer",
          "Function Generator",
          "IC Tester",
          "Interface and Study Cards",
          "Microprocessor Trainers",
        ],
      },
    ],
  },
];
export function findSubcategory(slug) {
  return catalogue.find(c => c.slug === slug);
}
export function subcategoriesByCategory(cat) {
  return catalogue.filter(c => c.category === cat);
}